import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { IMetrics } from './metrics.slice'

const getMetrics = (state: RootState) => state.metrics.data

const makePipelineGrantsMetrics = createSelector(getMetrics, (metrics) => {
  const { totalGrants = 0, planning = 0, submitted = 0 } = metrics

  return [
    {
      label: 'Total grants',
      value: totalGrants,
    },
    {
      label: 'Planning',
      value: planning,
    },
    {
      label: 'Submitted',
      value: submitted,
    },
  ]
})

const makeMatchedGrantsMetrics = createSelector(getMetrics, (metrics) => {
  const { totalGrants = 0, selected = 0, rejected = 0 } = metrics

  return [
    {
      label: 'Total grants',
      value: totalGrants,
    },
    {
      label: 'Selected',
      value: selected,
    },
    {
      label: 'Rejected',
      value: rejected,
    },
  ]
})

const makeTotalMatches = createSelector([getMetrics], (metrics) => {
  const { totalGrants = 0 } = metrics

  return totalGrants
})

const makeTotalWonAmount = createSelector([getMetrics], (metrics) => {
  const { totalWonAmount = 0 } = metrics

  return totalWonAmount
})

const makeWonCount = createSelector([getMetrics], (metrics) => {
  const { won = 0 } = metrics

  return won
})

const makeRecentMatchesCount = createSelector([getMetrics], (metrics) => {
  const { recentMatches = 0 } = metrics

  return recentMatches
})

/*We are no longer using below all*/

const selectWon = createSelector(getMetrics, (metrics: IMetrics) => metrics.won)

const selectLoss = createSelector(getMetrics, (metrics: IMetrics) => metrics.loss)

const selectAgencies = createSelector(getMetrics, (metrics: IMetrics) => metrics.agencies)

const selectTotalOutcomes = createSelector(selectWon, selectLoss, (won, loss) => won + loss)

const selectWinPercentage = createSelector(selectWon, selectTotalOutcomes, (won, total) =>
  total === 0 ? 0 : (won / total) * 100,
)

const selectLossPercentage = createSelector(selectLoss, selectTotalOutcomes, (loss, total) =>
  total === 0 ? 0 : (loss / total) * 100,
)

/*no longer using above all*/

export const MetricsSelector = {
  selectWon,
  selectLoss,
  makeWonCount,
  selectAgencies,
  selectWinPercentage,
  selectLossPercentage,
  makeTotalMatches,
  makeTotalWonAmount,
  makeRecentMatchesCount,
  makeMatchedGrantsMetrics,
  makePipelineGrantsMetrics,
}
